/**
 * EmailJS Service
 * Sends:
 * 1. Confirmation email to customer
 * 2. Reservation notification to BoostF
 */

import emailjs from "@emailjs/browser";

const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;

// Customer Template
const CUSTOMER_TEMPLATE =
  process.env.REACT_APP_EMAILJS_AUTOREPLY_TEMPLATE_ID;

// Admin Template
const ADMIN_TEMPLATE =
  process.env.REACT_APP_EMAILJS_CONTACT_TEMPLATE_ID;

const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

export const EMAIL_CONFIGURED = () =>
  Boolean(
    SERVICE_ID &&
      CUSTOMER_TEMPLATE &&
      ADMIN_TEMPLATE &&
      PUBLIC_KEY
  );

export async function sendReservationEmail({
  name,
  email,
  phone,
  paymentId,
  amountInr = 2499,
}) {
  if (!EMAIL_CONFIGURED()) {
    console.error("EmailJS not configured.");
    return;
  }

  const data = {
    user_name: name,
    user_email: email,
    user_phone: phone,
    payment_id: paymentId || "N/A",
    amount: amountInr,
    community_link:
      process.env.REACT_APP_WHATSAPP_INVITE_URL,
  };

  try {
    // ------------------------
    // Customer Confirmation
    // ------------------------

    await emailjs.send(
      SERVICE_ID,
      CUSTOMER_TEMPLATE,
      data,
      PUBLIC_KEY
    );

    console.log("Customer email sent.");

    // ------------------------
    // Admin Notification
    // ------------------------

    await emailjs.send(
      SERVICE_ID,
      ADMIN_TEMPLATE,
      {
        ...data,

        to_email: "boostf.support@gmail.com",
      },
      PUBLIC_KEY
    );

    console.log("Admin email sent.");

    return { ok: true };
  } catch (err) {
    console.error(err);

    return {
      ok: false,
      error: err,
    };
  }
}